// extracted by mini-css-extract-plugin
export var form = "_42-0";